<template>
    <v-container>
        <v-row>
            <v-col md="10">
                <calendar-card></calendar-card>
            </v-col>
             <v-col md="2" class="pl-0">
                <alerts-card></alerts-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="6" class="pt-0">
                <TNSOverview></TNSOverview>
            </v-col>
            <v-col md="6" class="pt-0">
                <TNSConfirmed></TNSConfirmed>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import CalendarCard from "@/components/cards/CalendarCard.vue";
import AlertsCard from "@/components/cards/AlertsCard.vue";
import TNSOverview from "@/components/cards/TNSOverview.vue";
import TNSConfirmed from "@/components/cards/TNSConfirmed.vue";
export default {
    name: "Dashboard",
    components: {
        AlertsCard,
        CalendarCard,
        TNSOverview,
        TNSConfirmed,
    },
    data(){
        return {
        }
    },
}
</script>